<template>
    <div class="playVideo">
        <video src="" class="video-box"></video>
    </div>
</template>

<script>
  export default {
    name: "video"
  }
</script>

<style scoped lang="less">
    .playVideo{
        height: 100%;
        background:#000000;
        .video-box{
            width: 750px;
        }
    }
</style>
